export default __webpack_public_path__ + "static/media/RUBY.ad0e3edb.png";